<app-page-container>
  <div class="opcoes">
    <div class="titulo">
      <span>Gestão de Acessos</span>
    </div>

    <div class="tab-navegacao">
      <button class="usuarios__button__style" *ngIf="autorizacoes.listarUsuarios">Usuários</button>
      <button routerLink="/gestao-de-acesso/perfil" class="ml-4" *ngIf="autorizacoes.listarPerfis">Perfis</button>
    </div>

    <div class="sub-titulo my-2">
      Usuários
    </div>

    <form [formGroup]="filtraForm" class="form-inline my-2 my-lg-0">
      <div class="d-flex mb-4 justify-content-between">
        <div class="w-25">
          <input class="form-control mr-sm-2 my-sm-0" type="search" placeholder="Pesquisar..." aria-label="Search"
            formControlName="nome">
        </div>
        <app-botao-incluir *ngIf="autorizacoes.controlarUsuarios" (click)="cadastrarUsuario()"
          [title]="'Adicionar Novo Usuário'"></app-botao-incluir>
      </div>
    </form>
    <app-tabela [cabecalhos]="['ID', 'Nome', 'E-mail', 'Tipo', 'Perfil', 'Ações']" [items]="usuarios.registros"
      [colunasOcultas]="['Ações']"
      [condicoesColunas]="[{ columnName: 'Ações', condition: autorizacoes.controlarUsuarios }]">
      <tr *ngFor="let usuario of usuarios.registros">
        <td>{{usuario.id}}</td>
        <td>{{usuario.nome}}</td>
        <td>{{usuario.email}}</td>
        <ng-container [ngSwitch]="true">
          <td *ngSwitchCase="usuario.tipoUsuario === 'EXT'">Externo</td>
          <td *ngSwitchDefault="">Interno</td>
        </ng-container>
        <td>{{usuario.nomePerfil}}</td>
        <td *ngIf="autorizacoes.controlarUsuarios">
          <div *ngIf="token.id !== usuario.id" class="editar-excluir">
            <button (click)="ativarOuDesativarUsuario(usuario)" class="desativar__style">
              {{ usuario.statusUsuario === 'ATIVO' ? 'Desativar' : 'Ativar'}}</button>
            <button (click)="excluirUsuario(usuario)" class="excluir__style">Excluir</button>
            <button *ngIf="usuario.statusUsuario === 'ATIVO'" (click)="editarUsuario(usuario)"
              class="editar__style">Editar</button>
          </div>
        </td>
      </tr>
    </app-tabela>
  </div>
  <app-paginacao nomeDaLista="Usuários" [(dados)]="usuarios" (dadosChange)="getUsuarios()"
    *ngIf="this.usuarios.registros.length !== 0"></app-paginacao>
</app-page-container>
<app-modal-cadastrar-usuario *ngIf="autorizacoes.controlarUsuarios"
  (registerUser)="getUsuarios(true)"></app-modal-cadastrar-usuario>
<app-modal-editar-usuario *ngIf="autorizacoes.controlarUsuarios"
  (updateUser)="getUsuarios(true)"></app-modal-editar-usuario>
<app-modal-excluir-usuario *ngIf="autorizacoes.controlarUsuarios"
  (deleteUser)="getUsuarios(true)"></app-modal-excluir-usuario>
<app-modal-ativar-ou-desativar-usuario *ngIf="autorizacoes.controlarUsuarios"
  (ativaDesativaUsuario)="getUsuarios(true)"></app-modal-ativar-ou-desativar-usuario>